import { RemoteData } from 'app/infrastructure/remote-data';
import { ApiResponse } from 'app/types-shared';
import { endpoint } from './constants';
import { ImportCaseUpdateData } from './types';
import { ImportCase } from 'app/area/import/types-store';

export const api = {
  loadImportList: async (startIndex: number, maxResults: number, includeImportTransDetails: boolean = false): Promise<ImportCase[]> => {
    const response = await new RemoteData(endpoint.loadCaseImport)
      .resource<ApiResponse<ImportCase[]>>()
      .filter({ startIndex, maxResults, includeImportTransDetails })
      .single();
    return response.data;
  },

  loadEditImport: async (importFileId: number): Promise<ImportCase> => {
    const response = await new RemoteData(endpoint.loadEditImport(importFileId))
      .resource<ApiResponse<ImportCase>>()
      .single();
    return response.data;
  },

  retryImport: async (importFileId: number) => {
    return await new RemoteData(endpoint.retryImport)
      .resource()
      .withId(importFileId)
      .create(undefined, false);
  },

  updateImport: async (importCaseUpdateData: ImportCaseUpdateData) => {
    return new RemoteData(endpoint.updateImport)
      .resource()
      .save(importCaseUpdateData);
  },

  deleteImport: async (importFileId: number) => {
    return new RemoteData(endpoint.deleteImport)
      .resource()
      .filter({ importFile: importFileId })
      .httpDelete(importFileId);
  }
};
